module.exports = __webpack_public_path__ + "tausta_oik.80e470e04579cacc8047.jpg";


//////////////////
// WEBPACK FOOTER
// C:/DEV/saaristonsiirin/src/assets/img/tausta_oik.jpg
// module id = ../../../../../src/assets/img/tausta_oik.jpg
// module chunks = 2